<template>
  <div class="LoanAmountInput ">
    <div class="input_box temr">
      <div class="inputShell">
        <div class="inputBox">
          <span v-if="params.title" :class="`title ${params.field}`">{{ params.title }}</span>
          <div class="inputItem">
            <input
              class="inputContainer"
              :disabled="params.disabled"
              :placeholder="params.props.placeholder"
              :maxLength="maxLength"
              @input="changeInput"
              v-model="value"
              type="text"
            />
            <div class="error" :style="{ color: 'red' }" v-if="message.message && value !== ''">{{ message.message }}</div>
          </div>
        </div>
        <van-icon  v-if="!params.disabled && allowClearHandler && value" @click="allowClear" class="allowClear" name="cross" />
      </div>
      <span class="end">万元</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoanAmountInput',
  props: ['params', 'errorMessage', 'allowClearHandler', 'form'],
  data() {
    return {
      error: '',
      isDelete: false,
      message: {
        field: 'loanAmount',
        message: '',
      },
      value: '',
      maxLength: 0,
    };
  },
  computed: {
    maxlength() {
      return this.params.props.max.toString().length;
    },
  },
  watch: {
    value: {
      handler(val, oldVal) {
        if (oldVal !== val) {
          this.$emit('input', val);
        }
      },
    },
    'params.initValue': {
      handler(val) {
        if (val !== this.value) {
          this.value = val;
        }
      },
    },
    errorMessage: {
      handler(val) {
        this.message.message = val.message;
      },
    },
    'params.props.max': {
      handler() {
        this.maxLength = this.params.props.max.toString().length;
      },
      immediate: true,
    },
  },
  methods: {
    allowClear() {
      this.value = '';
      this.allowClearHandler();
    },
    changeInput() {
      const { inputVal } = this.amountRuleJudgment({
        min: this.params.props.min,
        max: this.params.props.max,
        value: this.value,
      });
      const deleteZero = inputVal.replace(/^0/, '');
      this.value = deleteZero;
      this.$emit('input', deleteZero);
    },
    // 金额规则判断
    amountRuleJudgment({ value }) {
      // 正整数
      const inputVal = JSON.parse(JSON.stringify(value)).replace(/[^0-9]/g, '');
      return {
        inputVal,
      };
    },
    clickDelete() {
      this.value = '';
    },
  },
};
</script>
<style scoped lang="scss">
.LoanAmountInput {
  position: relative;
  display: flex;
  background: #fff;
  width: 100%;
}
.input_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  width: 100%;
}
.inputContainer {
  display: inline-block;
  border: none;
  font-size: 16px;
  padding: 0;
  width: 200px;
}
.allowClear {
  font-size: 14px;
  color: #9e9fa0;
  position: absolute;
  top: 4px;
  right: 41px;
}
.inputShell {
  position: relative;
  background: #fff;
  width: 100%;
}
.end {
  position: absolute;
  right: 16px;
}
.inputBox {
  background: #fff;
  flex: 1;
  display: flex;
  .inputItem {
    display: inline-block;
    position: relative;
    display: flex;
    flex: 1;
    .error {
      position: absolute;
      bottom: -11px;
    }
  }
}
.error {
  font-size: 12px;
}
.title {
  margin-right: 16px;
  font-size: 14px;
  color: #46494D;
  text-align: left;
  font-weight: 400;
  word-wrap: break-word;
  width: 86px;
}
input::-webkit-input-placeholder {
  color: #BCC2CC;
  font-size: 16px;
}
input::-moz-input-placeholder {
  color: #BCC2CC;
  font-size: 16px;
}
input::-ms-input-placeholder {
  color: #BCC2CC;
  font-size: 16px;
}
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: ' ';
  pointer-events: none;
}
</style>
